export default __webpack_public_path__ + "static/c02-6bcd36bafffa7d2e98963cba509a0f19.png";